// extracted by mini-css-extract-plugin
module.exports = {"btn_box":"FJKeyword_btn_box__2q4nN","text_box":"FJKeyword_text_box__hXBj6"};